import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BehaviorSubject } from 'rxjs';
import { Inject } from '@angular/core';
import { CarrierData } from 'src/app/shared/sl-data/carrier';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-create-worker-role-modal',
  templateUrl: './create-worker-role-modal.component.html',
  styleUrls: ['./create-worker-role-modal.component.scss']
})
export class CreateWorkerRoleModalComponent {
  editForm: FormGroup;
  operationInProg$ = new BehaviorSubject<'CREATE' | 'UPDATE' | 'DELETE' | null>(null);

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CreateWorkerRoleModalComponent>,
    private carrierData: CarrierData,
    private utilities:UtilitiesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editForm = this.fb.group({
      name: [data.name || '', Validators.required],
      description: [data.description || '', Validators.required]
    });
  }

  async onEditFormSubmit(formValue: any) {
    if (!this.editForm.valid) {
        return;
    }
    try{
        this.operationInProg$.next(!this.data.userId ? 'CREATE' : 'UPDATE');
        if(!this.data.id){
          await this.carrierData.createCarrierWorkerRole(formValue.name, formValue.description);
        }
        else{
            await this.carrierData.updateCarrierWorkerRole(this.data.id, formValue.name, formValue.description);
        }
        
        this.dialogRef.close();
        this.utilities.notifySuccess(!this.data.id ? 'Carrier worker role created successfully.' : 'Carrier worker role updated successfully.');
      }
      catch(err){
          if(err.details){
              this.utilities.notifyError(err.details);
              return;
          }
          this.utilities.notifyError(!this.data.id ? 'Unexpected error creating carrier worker role. Please contact system admin' : 'Unexpected error updating carrier user. Please contact system admin');
      }
      finally{
        this.operationInProg$.next(null);
      }
  }

  close() {
    this.dialogRef.close();
  }
} 